import { Check, Copy, RotateCcw, Share2, ThumbsDown, ThumbsUp, Volume2 } from "lucide-react";
import { useState } from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import type { Message } from "../types";

type MessageViewProps = { message: Message; onRetry?: () => void };

export function MessageView({ message, onRetry }: MessageViewProps) {
  const [copied, setCopied] = useState(false);
  const [feedback, setFeedback] = useState<"up" | "down" | null>(null);

  const copyMessage = async () => {
    await navigator.clipboard.writeText(message.content);
    setCopied(true);
    window.setTimeout(() => setCopied(false), 1400);
  };

  const speak = () => {
    window.speechSynthesis.cancel();
    window.speechSynthesis.speak(new SpeechSynthesisUtterance(message.content));
  };

  const share = async () => {
    if (navigator.share) await navigator.share({ text: message.content });
    else await copyMessage();
  };

  if (message.role === "user") {
    return (
      <article className="message message--user">
        <div className="message__inner message__inner--user">
          <div className="message-label"><strong>나</strong><time>{message.createdAt}</time></div>
          <div className="user-bubble">{message.content}</div>
        </div>
      </article>
    );
  }

  return (
    <article className="message message--assistant">
      <div className="message__inner">
        <div className="message-label"><strong>Hermes</strong><time>{message.createdAt}</time></div>
        <div className="markdown-body">
          <ReactMarkdown remarkPlugins={[remarkGfm]}>{message.content}</ReactMarkdown>
          {message.pending && <span className="stream-cursor" aria-label="응답 생성 중" />}
        </div>
        {!message.pending && (
          <div className="message-actions" aria-label="답변 작업">
            <button type="button" onClick={copyMessage} aria-label={copied ? "복사됨" : "답변 복사"}>{copied ? <Check size={17} /> : <Copy size={17} />}</button>
            <button type="button" className={feedback === "up" ? "is-active" : ""} onClick={() => setFeedback(feedback === "up" ? null : "up")} aria-label="좋은 답변"><ThumbsUp size={17} /></button>
            <button type="button" className={feedback === "down" ? "is-active" : ""} onClick={() => setFeedback(feedback === "down" ? null : "down")} aria-label="좋지 않은 답변"><ThumbsDown size={17} /></button>
            <button type="button" onClick={speak} aria-label="소리 내어 읽기"><Volume2 size={18} /></button>
            <button type="button" onClick={share} aria-label="답변 공유"><Share2 size={17} /></button>
            {onRetry && <button type="button" onClick={onRetry} aria-label="답변 다시 생성"><RotateCcw size={17} /></button>}
          </div>
        )}
      </div>
    </article>
  );
}
